import "@flaticon/flaticon-uicons/css/all/all.css";

export const IconHome = () => <i className="fi fi-rr-home" />;

export const IconDelete = () => <i className="fi fi-br-trash" />;

export const IconDisconnect = () => <i className="fi fi-rr-power" />;

export const IconEdit = () => <i className="fi fi-br-pencil" />;

export const IconReplace = () => <i className="fi fi-br-replace" />;

export const IconChevronDown = () => (
  <i className="fi fi-br-angle-small-down" />
);

export const IconChevronUp = () => <i className="fi fi-br-angle-small-up" />;

export const IconClose = () => <i className="fi fi-rr-cross" />;

export const IconError = () => <i className="fi fi-rr-cross" />;

export const IconArrowRight = () => <i className="fi fi-br-arrow-right" />;

export const IconCoucou = () => <i className="fi fi-br-hand-wave" />;

export const IconUpload = () => <i className="fi fi-br-upload" />;

export const IconSave = () => <i className="fi fi-br-disk" />;

export const IconGraduationCap = () => (
  <i className="fi fi-br-graduation-cap" />
);

export const IconPlay = () => <i className="fi fi-sr-play-alt" />;

export const IconPower = () => <i className="fi fi-br-power" />;

export const IconHouseWindow = () => <i className="fi fi-br-house-window" />;

export const IconLoading = () => <i className="fi fi-br-loading" />;

export const IconTable = () => <i className="fi fi-br-table" />;

export const IconFileExport = () => <i className="fi fi-br-file-export" />;

export const IconSearch = () => <i className="fi fi-br-search" />;

export const IconUsers = () => <i className="fi fi-br-users-gear" />;

export const IconCalendarDay = () => <i className="fi fi-br-calendar-day" />;

export const IconFileDownload = () => <i className="fi fi-br-file-download" />;

export const IconUser = () => <i className="fi fi-br-user" />;

export const IconUserPen = () => <i className="fi fi-br-user-pen" />;

export const IconAddUsers = () => <i className="fi fi-br-users-medical" />;

export const IconAddUser = () => <i className="fi fi-br-user-add" />;

export const IconExport = () => <i className="fi fi-br-file-export" />;

export const IconInfo = () => <i className="fi fi-br-info" />;

export const IconPhone = () => <i className="fi fi-br-phone-call" />;

export const IconBookCopy = () => <i className="fi fi-br-book-copy" />;

export const Toggle = ({ toggled = false }: { toggled: boolean }) => (
  <i className={toggled ? "fi fi-rr-toggle-on" : "fi fi-rr-toggle-off"} />
);
export const IconOverview = () => <i className="fi fi-br-overview" />;

export const IconCheck = () => <i className="fi fi-br-check" />;

export const IconCross = () => <i className="fi fi-br-cross-small" />;
